import React, { Component, ButtonHTMLAttributes } from 'react';

type ChannelButtonType = {
  onTap: (e: React.MouseEvent | React.TouchEvent) => void,
  htmlElement: string
}

const MIN_SWIPING_DISTANCE = 50;

export default class ChannelButton<T extends string> extends Component<ButtonHTMLAttributes<T> & ChannelButtonType, {}> {
  _swipe: {
    swiping: boolean,
    x: number,
    y: number
  }

  constructor(props: ChannelButtonType) {
    super(props);

    this._onTouchStart = this._onTouchStart.bind(this);
    this._onTouchMove = this._onTouchMove.bind(this);
    this._onTouchEnd = this._onTouchEnd.bind(this);

    this._swipe = {
      swiping: false,
      x: 0,
      y: 0
    };
  }

  _onTouchStart = (e: React.TouchEvent) => {
    const touch = e.touches[0];
    this._swipe = {
      swiping: false,
      x: touch.clientX,
      y: touch.clientY
    };
  }

  _onTouchMove = (e: React.TouchEvent) => {
    if (e.changedTouches && e.changedTouches.length) {
      this._swipe.swiping = true;
    }
  }

  _onTouchEnd = (e: React.TouchEvent) => {
    const touch = e.changedTouches[0];
    const distSwiped = Math.hypot(touch.clientX-this._swipe.x, touch.clientY-this._swipe.y);
    if (!this._swipe.swiping || distSwiped < MIN_SWIPING_DISTANCE ) {
      this.props.onTap && this.props.onTap(e);
    }
  }

  _onClick = (e: React.MouseEvent) => {
    this.props.onTap && this.props.onTap(e);
  }

  _omit = (omitted: string[], object: {[key: string]: any}) => Object.keys(object)
    .filter(key => !omitted.includes(key))
    .reduce((obj: {[key: string]: any}, key) => {
      obj[key] = object[key];
      return obj;
    }, {});

  render() {
    return React.createElement(this.props.htmlElement, {...this._omit(['onTap', 'htmlElement'], this.props),
      onTouchStart: this._onTouchStart,
      onTouchMove: this._onTouchMove,
      onTouchEnd: this._onTouchEnd,
      onClick: this._onClick
    }, this.props.children);
  }

}